import { axios } from "../../lib/axios";

export const DeleteOfflineCourse = (courseId: string) => {
    return axios.delete(`/offline-course/${courseId}`)
        .then(response => response.data);
};